<template>
  <div class="section-container">
    <div class="section-top">
      <div class="flex items-center">
        <p class="section-title mr-3">{{ title }}</p>
        <sf-icon
                 @click="openModal"
                 size="lg"
                 :icon="['fas', 'info-circle']"
                 :style="{ cursor: 'pointer', cursor: 'pointer', marginTop: '-3px' }" />
      </div>
      <p class="section-number">{{ step }}/{{ totalSteps }}</p>
    </div>
    <div class="section-bottom">
      <div class="flex" :class="{ 'mb-6': cardContent }" v-html="cardContent"></div>

      <div class="flex flex-col w-full mt-2 mb-4">
        <label for="breite" class="text-lg font-bold">Breite</label>
        <input
               type="text"
               name="Breite"
               id="breite"
               class="border rounded border-gray-300 p-2 mb-1"
               :value="width"
               @input="updateWidth"
               step="1"
               :max="Math.round(nextNearest(largestWidthOption) * 100)"
               :min="smallestWidthOption" />
        <p class="text-sm text-gray-500">
          in Zentimetern | min. {{ Math.round(Number(smallestWidthOption) * 100) }}cm | max.
          {{ Math.round(nextNearest(largestWidthOption) * 100) }}cm
        </p>
        <p v-if="showWidthError" class="bg-red-200 rounded mt-1 mb-1 px-2 py-1 text-sm">
          Wählen Sie bitte eine Breite zwischen <strong>{{ Math.round(Number(smallestWidthOption) * 100) }}cm</strong>
          und
          <strong>{{ Math.round(nextNearest(largestWidthOption) * 100) }}cm</strong>
        </p>
        <p v-if="closeToSmallerOption" class="bg-yellow-300 rounded mt-1 mb-1 px-2 py-1 text-sm">
          Wenn Sie die Breite um <strong>{{ differenceToSmaller }}cm</strong> reduzieren, sparen Sie
          <strong>{{ priceDifferenceToSmallerOption | formatPrice }}€</strong>
        </p>
      </div>
      <div class="flex flex-col w-full">
        <label for="ausfall" class="text-lg font-bold">Ausfall</label>
        <select
                class="border rounded border-gray-300 px-2 py-2 mb-1 bg-white transition-colors duration-300"
                @change="chooseVariation"
                :class="{ 'sf-pulse': highlightDepthSelection }">
          <option v-for="option in filteredOptions" :key="option.id" :selected="selection.id == option.id"
                  :value="option.id">
            {{ Math.round(Number(getAttributeValue(option, "Ausfall").replace(",", ".")) * 100) }}cm
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAttributeValue } from "./plentyHelpers";
import { fetchCategoryContent } from "./Helpers";

export default {
  name: "Dimensions",
  props: ["category", "step", "totalSteps"],

  data() {
    return {
      modalContent: "",
      title: "Maße",
      cardContent: "",
      showWidthError: false,
      highlightDepthSelection: false,
      // Used select new variation with matching Ausfall after user changes the Width
      previousDepth: null,
    };
  },

  async created() {
    let { modalContent, title, cardContent } = await this.fetchCategoryContent(this.category, this.$setPreview);
    this.modalContent = modalContent;
    if (title) this.title = title;
    if (cardContent) this.cardContent = cardContent;
  },

  computed: {
    ...mapState("dimensions/", {
      width: (state) => state.width,
      options: (state) => state.options,
      selection: (state) => state.selection,
    }),

    ...mapState("set/", {
      dimensionImage: (state) => state.dimensionImage,
    }),

    filteredOptions() {
      // Options that are large enough and dont exceed their maxWidth
      return this.options.filter((option) => {
        let width = parseFloat(this.getAttributeValue(option, "Breite").replace(",", "."));
        let maxWidth = parseFloat(this.getAttributeValue(option, "BreiteMax").replace(",", "."));
        let widthInMeters = this.width / 100;

        return widthInMeters >= width && widthInMeters <= maxWidth;
      });
    },

    largestWidthOption() {
      let largestWidth;

      this.options.forEach((option) => {
        let width = parseFloat(this.getAttributeValue(option, "Breite").replace(",", "."));
        if (!largestWidth) largestWidth = width;
        if (width > largestWidth) largestWidth = width;
      });

      return largestWidth;
    },

    smallestWidthOption() {
      let smallestWidth;

      this.options.forEach((option) => {
        let width = parseFloat(this.getAttributeValue(option, "Breite").replace(",", "."));
        if (!smallestWidth) smallestWidth = width;
        if (width < smallestWidth) smallestWidth = width;
      });

      return smallestWidth;
    },

    closeToSmallerOption() {
      if (!this.smallerOption) return false;
      // If the current width is within 5% of lowest possible width of the current selection - return true
      let smallerWidth = Number(this.getAttributeValue(this.selection, "Breite").replace(",", "."));
      let width = this.width / 100;
      console.log({width, smallerWidth});
      
      // return width <= smallerWidth * 1.05;
      return (width - smallerWidth) < 0.09;
    },

    differenceToSmaller() {
      if (!this.closeToSmallerOption) return 0;
      let currentWidhtOption = Number(this.getAttributeValue(this.selection, "Breite").replace(",", "."));
      let width = this.width / 100;

      return Math.round((width - currentWidhtOption) * 100) + 1;
    },

    priceDifferenceToSmallerOption() {
      if (!this.closeToSmallerOption) return 0;

      let option = this.smallerOption;
      if (!this.selection) return 0;
      if (!this.selection.variationSalesPrices) return 0;

      let optionPrice = option.variationSalesPrices[0].price;
      let selectedPrice = this.selection.variationSalesPrices[0].price;
      return optionPrice - selectedPrice;
    },

    smallerOption() {
      let widthOptions = {};
      let currentDepth = Number(this.getAttributeValue(this.selection, "Ausfall").replace(",", "."));

      this.options.forEach((option) => {
        let width = parseFloat(this.getAttributeValue(option, "Breite").replace(",", "."));
        let depth = parseFloat(this.getAttributeValue(option, "Ausfall").replace(",", "."));

        if (depth == currentDepth) widthOptions[width] = option;
      });

      let widthOptionsKeys = Object.keys(widthOptions);

      // Filter out duplicates
      widthOptionsKeys = widthOptionsKeys.filter((item, index) => widthOptionsKeys.indexOf(item) === index);

      // Sort the width options
      widthOptionsKeys.sort((a, b) => a - b);

      // Find the nearest lower width option
      if (!this.selection) return null;
      let currentWidthOption = Number(this.getAttributeValue(this.selection, "Breite").replace(",", "."));

      let currentIndex = widthOptionsKeys.findIndex((widthOption) => {
        return widthOption == currentWidthOption;
      });

      if (currentIndex < 1) return null;
      let smallerOptionIndex = currentIndex - 1;
      let smallerWidthOption = widthOptionsKeys[smallerOptionIndex];

      return widthOptions[smallerWidthOption] || null;
    },
  },

  methods: {
    getAttributeValue,
    fetchCategoryContent,

    ...mapMutations("dimensions/", {
      setWidth: "setWidth",
      setSelection: "setSelection",
    }),

    nextNearest(value) {
      let number = 0.5;
      let ceil = Math.ceil(value);
      let remainder = value % number;
      if (remainder > 0) value = value - remainder + number;
      return value;
    },

    chooseVariation(event) {
      let selection = this.options.find((option) => {
        return option.id == event.target.value;
      });

      this.setSelection(selection);
    },

    updateWidth(width) {
      if (width.target.value) this.setWidth(this.parseNumber(width));
    },

    openModal() {
      this.$store.commit("modal/openModal")
      this.$store.dispatch("modal/setBody", this.modalContent);
      this.$store.dispatch("modal/setTitle", this.title);
    },

    parseNumber(event) {
      let number = event.target.value;

      // Parse number string into number and turn comma into decimal seperator
      return parseFloat(number.replace(",", "."));
    },

    flashDepthSelection() {
      this.highlightDepthSelection = true;

      setTimeout(() => {
        this.highlightDepthSelection = false;
      }, 1500);
    },
  },

  watch: {
    dimensionImage(image) {
      this.modalContent += `<div style="width: 100%; margin-top: 30px;"><img style="width: 100%"; src="${image}"></img></div>`;
    },

    selection(selection) {
      let currentDepth = parseFloat(this.getAttributeValue(selection, "Ausfall").replace(",", "."));
      console.log({ currentDepth });
      if (currentDepth) this.previousDepth = currentDepth;
    },

    // Automatically select a different variation if the current one is not available in the filtered options anymore
    filteredOptions(options) {
      let optionAvailable = options.some((option) => {
        return this.selection.id == option.id;
      });

      // Select a variation that has the same Ausfall (depth) if one is available
      if (!optionAvailable && this.previousDepth) {
        let optionWithMatchingDepth = this.filteredOptions.find((option) => {
          let depth = parseFloat(this.getAttributeValue(option, "Ausfall").replace(",", "."));
          return depth == this.previousDepth;
        });

        if (optionWithMatchingDepth) {
          this.setSelection(optionWithMatchingDepth);
          return (this.showWidthError = false);
        }
      }

      // If no variation with the same depth is available, select the first available variation and highlight it so the user notices the change
      if (options.length && !optionAvailable) {
        this.setSelection(options[0]);
        this.flashDepthSelection();
      }
    },

    smallestWidthOption(minWidth) {
      if (this.width < minWidth) this.setWidth(Math.round(minWidth * 100));
    },

    width(width) {
      if (width < this.smallestWidthOption * 100) {
        console.log("Width is smaller than smallest option");
        this.setSelection({});
        return (this.showWidthError = true);
      }

      this.showWidthError = false;
    },
  },
};
</script>

<style scoped>
.sf-pulse {
  font-weight: bold !important;
  background-color: #fbbe245c !important;
}
</style>
